import { render, staticRenderFns } from "./_user_external.form.vue?vue&type=template&id=50ffe476&scoped=true&"
import script from "./_user_external.form.vue?vue&type=script&lang=js&"
export * from "./_user_external.form.vue?vue&type=script&lang=js&"
import style0 from "./_user_external.form.vue?vue&type=style&index=0&id=50ffe476&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ffe476",
  null
  
)

export default component.exports